// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx"}[chunkId] + "-" + {"223":"6838d0dea6b096c6eae1","245":"e5eb028e2bd437d131e6"}[chunkId] + ".js";
};